import { colors } from '../../colors';
import Next from '../../../../static/images/icons/Next';
import Prev from '../../../../static/images/icons/Prev';
var carousel = {
  arrowBgColor: colors.slateGreen,
  arrowHoverBgColor: colors.militaryGreen,
  arrowForeColor: colors.white,
  arrowPrevMarginRightVarA: '4px',
  arrowNextMarginLeftVarA: '4px',
  highlightColor: colors.ash,
  paginationInactiveColor: colors.white,
  paginationActiveColor: colors.slateGreen,
  paginationBorderColor: colors.slateGreen,
  heroPaginationBorder: false,
  noBorderOnDesktopVariationAandB: true,
  heroPaginationInactiveColor: colors.white,
  heroPaginationInactiveColorMobile: colors.slateGreen,
  heroPaginationInactiveColorVariationC: colors.slateGreen,
  heroPaginationActiveColor: colors.slateGreen,
  heroPaginationBorderColor: colors.militaryGreen,
  fiveCardPaginationActiveColor: colors.white,
  bgColor: colors.alabaster,
  iconNext: Next,
  iconPrev: Prev
};
export default carousel;